module.exports = __webpack_public_path__ + "static/img/ultimate-capsule-wardrobe-guide.49664c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/ultimate-capsule-wardrobe-guide.jpg
// module id = 5dFr
// module chunks = 0